import { render, staticRenderFns } from "./table-chart.vue?vue&type=template&id=006cae11"
import script from "./table-chart.vue?vue&type=script&lang=js"
export * from "./table-chart.vue?vue&type=script&lang=js"
import style0 from "./table-chart.vue?vue&type=style&index=0&id=006cae11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports